import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ServicesList from '../../../components/List';
import Loader from '../../../components/Loader';
import List from './List';
import ImportEmptySearchServices from '../EmptySearch';
import ImportEmptyServices from '../EmptyServices';

import * as importTypes from '../../../reducer/constants';
import { splitToRows } from '../helper';

const Services = ({ list, isLoading, provider, dispatchImportState, search, scrollToCategoryId, scrollToServiceId, sortRate }) => {
  const showEmptySearch = isLoading ? false : search && !list.length;

  const splitList = useMemo(() => splitToRows(list), [list]);

  const onSortRate = () => {
    dispatchImportState({ type: importTypes.IMPORT_SORT_BY_RATE });
  };

  if (list) {
    return (
      <ServicesList.Wrapper>
        <ServicesList.ListHeader onSortRate={onSortRate} sortRate={sortRate} />
        {isLoading ? <Loader /> : null}
        {showEmptySearch ? <ImportEmptySearchServices /> : null}
        {!list.length && !search && !isLoading ? <ImportEmptyServices /> : null}
        <List
          list={splitList}
          categoryLength={list?.length || 0}
          isLoading={isLoading}
          provider={provider}
          dispatchImportState={dispatchImportState}
          search={search}
          scrollToCategoryId={scrollToCategoryId}
          scrollToServiceId={scrollToServiceId}
        />
      </ServicesList.Wrapper>
    );
  }

  return null;
};

Services.propTypes = {
  list: PropTypes.array,
  isLoading: PropTypes.bool,
  provider: PropTypes.object,
  dispatchImportState: PropTypes.func,
  search: PropTypes.string,
  scrollToCategoryId: PropTypes.number,
  scrollToServiceId: PropTypes.number,
  sortRate: PropTypes.string,
};

export default Services;
